import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/payments/wava`;

const model = abstractModel(resource);

model.disconnect = async () => {
  const newResource = `${resource}/disconnect`;

  return model.get({}, { path: newResource });
};

model.linkBy = async (params) => {
  const newResource = `${resource}/link_by`;

  return model.save(params, { path: newResource });
};

export default model;
